export function checkIsLinkedinOrganizationProfile(id?: string): boolean {
  if (!id) {
    return false;
  }

  return id.includes('organization');
}
